// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search[data-v-1bcbb7b4]{color:#555;font-size:14px;height:56px;max-width:500px}.search[data-v-1bcbb7b4]:not(.search__modal){width:calc(100vw - 180px)}@media screen and (max-width:600px){.search[data-v-1bcbb7b4]:not(.search__modal){width:calc(100vw - 110px)}}.search__modal[data-v-1bcbb7b4]>div{height:40px;margin-right:-16px;margin-top:-8px;width:-moz-min-content;width:min-content}.search__results[data-v-1bcbb7b4]{min-height:200px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
